import LegalLayout, { H2, P, UL, PH } from "../LegalLayout";

export default function Impressum() {
  return (
    <LegalLayout title="Impressum">
      <PH>
        Angaben gemäß § 5 DDG (Digitale-Dienste-Gesetz). Trage hier deine vollständigen und wahrheitsgemäßen Angaben ein —
        ein Impressum ohne echte Angaben darf nicht veröffentlicht werden.
      </PH>

      <H2>Anbieter</H2>
      <PH>
        [Vor- und Nachname des Inhabers]
        <br />
        [Straße und Hausnummer]
        <br />
        [PLZ und Ort]
        <br />
        Deutschland
      </PH>

      <H2>Kontakt</H2>
      <UL
        items={[
          "E-Mail: support@mazaro.de",
          <>
            Telefon: <PH>[deine Telefonnummer]</PH>
          </>,
        ]}
      />

      <H2>Umsatzsteuer-ID</H2>
      <PH>
        Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz: [DE-Nummer, falls vorhanden — sonst diesen
        Abschnitt entfernen]
      </PH>

      <H2>Verantwortlich für den Inhalt</H2>
      <PH>
        Verantwortlich gemäß § 18 Abs. 2 MStV: [Vor- und Nachname], [Straße und Hausnummer, PLZ und Ort] — bei identischer
        Anschrift wie oben genügt der Hinweis „wie oben“.
      </PH>

      <H2>EU-Streitschlichtung</H2>
      <P>
        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
        <a
          href="https://ec.europa.eu/consumers/odr"
          target="_blank"
          rel="noreferrer"
          className="text-gold underline underline-offset-4"
        >
          https://ec.europa.eu/consumers/odr
        </a>
        . Unsere E-Mail-Adresse findest du oben im Impressum.
      </P>
      <PH>
        [Optional: Hinweis, ob du bereit bist, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
        teilzunehmen — Pflichtangabe, wenn du verpflichtet bist oder freiwillig teilnimmst.]
      </PH>

      <H2>Haftung für Inhalte</H2>
      <P>
        Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
        Wir sind jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach
        Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
      </P>
    </LegalLayout>
  );
}
